import { Checkbox } from '@smartsheet/lodestar-core';
import React from 'react';

export interface InputCheckboxProps {
  value: boolean;
  onChange: (value?: any) => void;
}

export const InputCheckbox = ({ value, onChange }: InputCheckboxProps) => {
  return (
    <Checkbox
      checkedState={value ? 'checked' : 'unchecked'}
      onClick={() => {
        onChange(!value);
      }}
    />
  );
};
